export default __webpack_public_path__ + "static/media/77.b568c0c4.png";